<template>
  <div>
    <span>{{ cat.points }}/{{ cat.maxPoints }}</span>
    -
    <BaseNumeral :number="cat.perc" format="0%" />

    <span v-if="cat.weight">
      -
      {{ cat.stars }}
      {{ $tc("report.stars", cat.stars) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "CategoryPoints",

  props: {
    categories: {
      type: Array,
      required: true,
    },

    category: {
      type: String,
      required: true,
    },
  },

  computed: {
    cat() {
      return this.categories.find((cat) => cat.category === this.category);
    },
  },
};
</script>
